import { InputGroupState } from "./context.types";
import { InputGroupAction, InputGroupActionType } from "./reducer.types";

export const reducer = (
  state: InputGroupState,
  action: InputGroupAction
): InputGroupState => {
  switch (action.type) {
    case InputGroupActionType.HOIST_MESSAGE: {
      const clonedChildrenStatus = [...state.childrenStatus];

      const childElement = clonedChildrenStatus.find(
        (child) => child.label === action.label
      );

      if (childElement) {
        childElement.status = action.status;
        childElement.statusMessage = action.statusMessage;
      } else {
        clonedChildrenStatus.push({
          label: action.label,
          status: action.status,
          statusMessage: action.statusMessage,
        });
      }

      const activeChildrenStatus = clonedChildrenStatus.find(
        (child) => !!child.status && !!child.statusMessage
      );

      const anyStatus = clonedChildrenStatus.find((child) => !!child.status);

      return {
        ...state,
        statusMessage: activeChildrenStatus?.statusMessage,
        status: activeChildrenStatus?.status || anyStatus?.status,
        childrenStatus: clonedChildrenStatus,
      };
    }

    default:
      return state;
  }
};
